import React, { useState } from 'react'
import { Menu, X } from 'lucide-react'
import Logo from './Logo'
import NavigationMenu from './NavigationMenu'
import SearchBar from './SearchBar'
import MobileMenu from './MobileMenu'

const MainNav: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  return (
    <nav className="bg-bg border-b border-border text-text-main sticky top-0 z-40 transition-colors duration-200">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20 gap-4">

          {/* اللوجو */}
          <Logo />

          {/* قائمة التنقل - للشاشات الكبيرة */}
          <div className="hidden lg:flex items-center space-x-8 space-x-reverse">
            <NavigationMenu />
          </div>

          {/* شريط البحث - للشاشات الكبيرة والمتوسطة */}
          <div className="hidden md:flex items-center flex-1 max-w-sm lg:max-w-md mx-4">
            <SearchBar />
          </div>

          {/* زر قائمة الجوال */}
          <div className="flex items-center gap-2 lg:hidden">
            <button
              onClick={toggleMobileMenu}
              className="p-2 rounded-lg text-[var(--text-2)] hover:text-[var(--gold)] hover:bg-[var(--surface)] border border-transparent hover:border-[var(--border)] transition-all duration-200 focus:outline-none"
              aria-label={isMobileMenuOpen ? "إغلاق القائمة" : "فتح قائمة الجوال"}
            >
              {isMobileMenuOpen ? <X size={24} className="text-[var(--gold)]" /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* شريط البحث - للشاشات الصغيرة (الموبايل) */}
        <div className="md:hidden pb-3 pt-1">
          <SearchBar />
        </div>
      </div>

      {/* قائمة الجوال */}
      <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />
    </nav>
  )
}

export default MainNav